// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHGOU478bReXal2Psyz2QACfWNSesFmRo",
  authDomain: "quellr-6b89f.firebaseapp.com",
  projectId: "quellr-6b89f",
  storageBucket: "quellr-6b89f.appspot.com",
  messagingSenderId: "876633746337",
  appId: "1:876633746337:web:58f5a204dd083de1abb9e0",
  measurementId: "G-E7W60TEX7X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;